// pages/Payment/index.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPendingRequest } from '../../store/slices/subscriptionSlice';
import { SUBSCRIPTION_STATES } from '../../config/constants';
import PaymentComponent from '../../components/subscription/PaymentComponent';
import { PaymentPageWrapper } from './styles';
import LoadingScreen from '../../components/common/loading/LoadingScreen';

const PaymentPage = () => {
    const pendingRequest = useSelector(selectPendingRequest);
    const loading = useSelector(state => state.subscription.loading);

    if (loading) {
        return <LoadingScreen loading={loading} />;
    }

    // Redirect if no pending payment request
    if (!pendingRequest || pendingRequest.status !== SUBSCRIPTION_STATES.PENDING_PAYMENT) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <PaymentPageWrapper>
            <PaymentComponent requestData={pendingRequest} />
        </PaymentPageWrapper>
    );
};

export default PaymentPage;